import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { addAlert } = useAlerts();

const LOGS_QUERY = gql`
  query Logs($since: String, $type: String, $user: String) {
    logs(since: $since, type: $type, user: $user) {
      ACTION
      COMPANYID
      CONTACTID
      CREATEDATE
      DIARYTEXT
      DIARYTYPE
      NAME
      company {
        NAME
      }
      contact {
        FIRSTNAME
        LASTNAME
      }
      user {
        LASTNAME
        FIRSTNAME
      }
    }
  }
`;

const LOG_ACTIONS_QUERY = gql`
  query Query {
    logsActions {
      ACTION
    }
  }
`;

export default function useLogsQuery() {
  function getLogs(since, type, user) {
    provideApolloClient(apolloClient);

    const { result, loading, error } = useQuery(LOGS_QUERY, () => ({ since, type, user }), { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching logs:', error.value);
        addAlert('Error fetching logs', 'high', 4);
      }
    });
    return { result, loading, error };
  }

  function getLogActions() {
    provideApolloClient(apolloClient);
    const { result, loading, error, refetch } = useQuery(LOG_ACTIONS_QUERY, {}, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching log actions:', error.value);
        addAlert('Error fetching log actions', 'high', 4);
      }
    });
    return { result, loading, error, refetch };
  }

  return { getLogs, getLogActions };
}
